import { render, staticRenderFns } from "./Constructions.vue?vue&type=template&id=095f640e&scoped=true"
import script from "./Constructions.vue?vue&type=script&lang=js"
export * from "./Constructions.vue?vue&type=script&lang=js"
import style0 from "./Constructions.vue?vue&type=style&index=0&id=095f640e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095f640e",
  null
  
)

export default component.exports